import { render, staticRenderFns } from "./AddOrEdit.vue?vue&type=template&id=625fa4a8&scoped=true"
import script from "./AddOrEdit.vue?vue&type=script&lang=js"
export * from "./AddOrEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "625fa4a8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/build/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('625fa4a8')) {
      api.createRecord('625fa4a8', component.options)
    } else {
      api.reload('625fa4a8', component.options)
    }
    module.hot.accept("./AddOrEdit.vue?vue&type=template&id=625fa4a8&scoped=true", function () {
      api.rerender('625fa4a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mchApp/AddOrEdit.vue"
export default component.exports